import { useAddUserMutation, useFetchUsersQuery } from "../store/apis/usersApi"
import Button from "./Button"
import UsersListItem from "./UsersListItem"
import { faker } from "@faker-js/faker"

const UsersList = () => {
  const { data, isLoading, error } = useFetchUsersQuery()
  const [addUser, addUserResult] = useAddUserMutation()

  const handleAddUser = () => {
    addUser({
      firstName: faker.person.firstName(),
      lastName: faker.person.lastName(),
      email: faker.internet.email(),
    })
  }

  let content
  if (isLoading) {
    content = <p>Loading...</p>
  } else if (error) {
    content = <p>Error: {error.message}</p>
  } else {
    content = data?.map((user) => <UsersListItem key={user.id} user={user} />)
  }

  return (
    <div>
      <div className="flex flex-row justify-between items-center">
        <h1 className="text-gray-300 text-sm">
          {data?.length} {data?.length === 1 ? "Owner" : "Owners"} were found
        </h1>
        <Button onClick={handleAddUser} loading={addUserResult.isLoading}>
          + Add User
        </Button>
      </div>

      {addUserResult.isError && <p>{addUserResult.error.message}</p>}

      {content}
    </div>
  )
}

export default UsersList
